/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelServizioListItemDTO } from '../model/paged-model-servizio-list-item-dto';
// @ts-ignore
import { ServiziListFilter } from '../model/servizi-list-filter';
// @ts-ignore
import { ServizioDTO } from '../model/servizio-dto';
// @ts-ignore
import { ServizioMensaOrarioAnnullamentoForm } from '../model/servizio-mensa-orario-annullamento-form';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    ServiziServiceInterface,
    GetServizioGestioneDetailRequestParams,
    ListServiziGestioneRequestParams,
    PatchServizioOrarioAnnullamentoRequestParams
} from './servizi.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class ServiziService extends BaseService implements ServiziServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Detail di un servizio con sottotipo inflated.
     * Audience: SUPERADMIN (qualsiasi), OP_COMUNE (solo se servizio.tipoPratica.comune.id ∈ comuniGestiti). Risposta: ServizioDTO Fase-14 (root + mensa annidato sse tipoServizio &#x3D; MENSA).
     * @endpoint get /api/v1/gestione/servizi/{id_servizio}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getServizioGestioneDetail(requestParameters: GetServizioGestioneDetailRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioDTO>;
    public getServizioGestioneDetail(requestParameters: GetServizioGestioneDetailRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioDTO>>;
    public getServizioGestioneDetail(requestParameters: GetServizioGestioneDetailRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioDTO>>;
    public getServizioGestioneDetail(requestParameters: GetServizioGestioneDetailRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idServizio = requestParameters?.idServizio;
        if (idServizio === null || idServizio === undefined) {
            throw new Error('Required parameter idServizio was null or undefined when calling getServizioGestioneDetail.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/servizi/${this.configuration.encodeParam({name: "idServizio", value: idServizio, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista paginata cross-bando dei servizi role-scoped.
     * Audience: SUPERADMIN (vede tutti), OP_COMUNE (scope automatico sui propri comuniGestiti). Filtri opzionali: q, tipo_servizio, comune_id, tipo_pratica_id, tipologia_pratica, stato, include_chiusi. Default sort: tipoPratica.codice ASC, dataInizio DESC.
     * @endpoint get /api/v1/gestione/servizi
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listServiziGestione(requestParameters: ListServiziGestioneRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelServizioListItemDTO>;
    public listServiziGestione(requestParameters: ListServiziGestioneRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelServizioListItemDTO>>;
    public listServiziGestione(requestParameters: ListServiziGestioneRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelServizioListItemDTO>>;
    public listServiziGestione(requestParameters: ListServiziGestioneRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling listServiziGestione.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listServiziGestione.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/servizi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelServizioListItemDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifica l\&#39;orario massimo di annullamento pasto di un servizio mensa.
     * Audience: SUPERADMIN (qualsiasi), OP_COMUNE (solo sui propri comuniGestiti). Unica scrittura sulla configurazione mensa concessa a OP_COMUNE: il resto resta SUPERADMIN-only sulla sub-resource di bando. Il campo governa anche l\&#39;orario dei report pasti, generati cinque minuti dopo il cutoff. Valore nullo o vuoto &#x3D; nessun orario impostato (lo scheduler usa il default 09:00).
     * @endpoint patch /api/v1/gestione/servizi/{id_servizio}/mensa/orario-annullamento
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public patchServizioOrarioAnnullamento(requestParameters: PatchServizioOrarioAnnullamentoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ServizioDTO>;
    public patchServizioOrarioAnnullamento(requestParameters: PatchServizioOrarioAnnullamentoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ServizioDTO>>;
    public patchServizioOrarioAnnullamento(requestParameters: PatchServizioOrarioAnnullamentoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ServizioDTO>>;
    public patchServizioOrarioAnnullamento(requestParameters: PatchServizioOrarioAnnullamentoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idServizio = requestParameters?.idServizio;
        if (idServizio === null || idServizio === undefined) {
            throw new Error('Required parameter idServizio was null or undefined when calling patchServizioOrarioAnnullamento.');
        }
        const servizioMensaOrarioAnnullamentoForm = requestParameters?.servizioMensaOrarioAnnullamentoForm;
        if (servizioMensaOrarioAnnullamentoForm === null || servizioMensaOrarioAnnullamentoForm === undefined) {
            throw new Error('Required parameter servizioMensaOrarioAnnullamentoForm was null or undefined when calling patchServizioOrarioAnnullamento.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/servizi/${this.configuration.encodeParam({name: "idServizio", value: idServizio, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/mensa/orario-annullamento`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ServizioDTO>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: servizioMensaOrarioAnnullamentoForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
